import paperclip from './theme/icons/paperclip.svg';
export { default as FileUpload } from './fileupload';
export const icons = {
    paperclip
};
